package com.milta.core.localization.translations.bg

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Отказ",
    confirm = "Потвърди",
    save = "Запази",
    delete = "Изтрий",
    back = "Назад",
    loading = "Зареждане…",
    retry = "Опитай отново",
    creationInProgressDoNotClose = "Създаването е в процес, не затваряйте прозореца",
    processingStepSent = "Документът е изпратен",
    processingStepReading = "Четене на документа",
    processingStepFinding = "Откриване на доставки",
    processingStepChecking = "Проверка на адресите",
    processingUsualDuration = "Обикновено 20 до 40 секунди. Останете на този екран, ние ще се погрижим за останалото.",
    processingLongWait = "Документът съдържа много информация, анализът отнема малко повече време от обичайното. Всичко работи, продължаваме.",
    processingInProgressSince = "В процес от %1",
    processingFinishedIn = "Завършено за %1",
    processingDeliveriesFound = "Намерени доставки: %1",
    processingDeliveriesFoundOne = "Намерена 1 доставка",
    processingAddressesChecked = "%1 от %2 адреса",
    addressVerifiedBadge = "✓ Адресът е проверен",
    addressNeedsReviewBadge = "⚠ Адресът трябва да се провери",
    addressFoundLine = "Намерен: %1",
    language = "Език",
    welcomeTitle = "Добре дошли в Milta",
    welcomeSubtitle = "Вашият интелигентен асистент за доставки",
    alreadyHaveAccount = "Вече имам акаунт",
    createAccount = "Създай акаунт",
    continueWithGoogle = "Продължете с Google",
    continueWithApple = "Продължете с Apple",
    oauthErrorGeneric = "Възникна грешка при влизането. Опитайте отново.",
    oauthAppleWebComingSoon = "Влизането с Apple ще бъде налично скоро в уеб версията.",
    oauthDriverAccountNotAllowedOnWeb = "Профилите на шофьори нямат достъп до уеб таблото. Влезте през мобилното приложение.",
    oauthAccountNotFoundOnWeb = "Не е намерен акаунт в Milta за този Google акаунт.",
    errorOffline = "Няма връзка с интернет.",
    navTourneesDuJour = "Днешни маршрути",
    navAjouterUneTournee = "Добавяне на маршрут",
    navHistoriqueDesPreuves = "История на доставките",
    navParametres = "Настройки",
    sidebarRoleManagerLabel = "Мениджър",
    noDeliveriesYetTitle = "Все още няма доставки",
    noDeliveriesYetSubtitle = "Докоснете „Добавяне на доставки“, за да добавите",
    optimizationUnavailableExplanation = "Искате ли да създадете маршрута без оптимизация, или да опитате отново?",
    createWithoutOptimizationAction = "Създай без оптимизация",
    gpsAppSheetTitle = "Изберете навигационно приложение",
    addressSearchingLabel = "Търсене…",
    clearTimeFieldAction = "Изчисти",
    clearTimeFieldConfirmTitle = "Да се изчисти ли часът?",
    clearTimeFieldConfirmMessage = "Текущият час ще бъде премахнат. Можете да зададете нов по всяко време.",
    updateRequiredTitle = "Задължителна актуализация",
    updateRequiredMessage = "Налична е нова версия на Milta. Актуализирайте приложението, за да продължите да го използвате.",
    updateInstalledVersionLabel = "Инсталирана",
    updateAvailableVersionLabel = "Налична",
    updateNowButton = "Актуализирай",
    updateDataKeptNote = "Вашите маршрути и доставки се запазват.",
    updateSendingPendingOne = "Изпращане на 1 доставка, потвърдена офлайн…",
    updateSendingPendingMany = "Изпращане на {count} доставки, потвърдени офлайн…",
)
